// eslint-disable-next-line import/prefer-default-export
export const INACTIVITY_DURATION = 60 * 600000
// export const INACTIVITY_DURATION = 30 * 60000
export const downloadTemplate = {
  batchLoanCreationCode: 2,
  batchCorporateCustomerAccountCode: 12,
  batchAccountCreationCode: 15,
  glCustomerUploadPostingCode: 16,
  batchDatingPostingCode: 18,
  batchIndividualCustomerCode: 19,
  assignedCardRequestCode: 22,
}
